import { useRef, useState, type DragEvent } from 'react'

import { useLatest } from './useLatest'

type Handler = (event: DragEvent<HTMLElement>) => void

const withFiles =
  (handler: Handler): Handler =>
  event => {
    if (![...event.dataTransfer.types].includes('Files')) return
    event.preventDefault()
    handler(event)
  }

export const useFileDrop = (onFiles: (files: File[]) => void) => {
  const [hot, setHot] = useState(false)
  const depth = useRef(0)
  const latest = useLatest(onFiles)

  const handlers = {
    onDragEnter: withFiles(() => {
      depth.current += 1
      setHot(true)
    }),
    onDragOver: withFiles(event => {
      event.dataTransfer.dropEffect = 'copy'
    }),
    onDragLeave: withFiles(() => {
      depth.current = Math.max(0, depth.current - 1)
      if (depth.current === 0) setHot(false)
    }),
    onDrop: withFiles(event => {
      depth.current = 0
      setHot(false)
      latest.current([...event.dataTransfer.files])
    }),
  }

  return { hot, handlers }
}
